<template>
  <v-btn
    color="white"
    class="save-progress-btn"
    icon
    :loading="loading.progress"
    :style="{ backgroundColor: isProgressMatching ? '#FF347C' : '#29284c' }"
    @click="onSaveProgress"
  >
    <v-icon color="white">mdi-pin</v-icon>
  </v-btn>
</template>

<script>
import { saveStudentProgress, getStudentProgress } from "@/api/api";
import studentMixin from "@/mixins/studentMixin";
import lessonStepContextMixin from "@/mixins/lessonStepContextMixin";

export default {
  mixins: [studentMixin, lessonStepContextMixin],
  data() {
    return {
      loading: {
        progress: false,
      },
      progress: null,
    };
  },
  computed: {
    isProgressMatching() {
      return (
        this.progress?.step_uuid === (this.stepUuid ?? null) &&
        this.progress?.step_number === this.stepNumber
      );
    },
  },

  methods: {
    async onSaveProgress() {
      this.loading.progress = true;
      try {
        const { data } = await saveStudentProgress({
          step_number: this.stepNumber,
          student: this.student.email,
          step_uuid: this.stepUuid,
          lesson: this.currentLesson.uuid,
          step_type: this.stepType,
        });
        this.progress = data;
      } finally {
        this.loading.progress = false;
      }
    },
  },

  async mounted() {
    try {
      const response = await getStudentProgress(this.student.uuid);
      this.progress = response.data;
    } catch {
      this.progress = null;
    }
  },
};
</script>

<style scoped>
.save-progress-btn {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 1000;
}
</style>
